import { render, staticRenderFns } from "./main.bodega.vue?vue&type=template&id=1e588161"
import script from "./main.bodega.vue?vue&type=script&lang=js"
export * from "./main.bodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports